// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TA78","top":"styles_top__2SW5v"};